import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DashboardService } from 'src/app/services/services/dashboard.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogSaveAsEditData, DialogSaveAsEditTypes, ReportsDialogSaveAsEditComponent } from 'src/app/reports/reports-details/nested-components/reports-dialog-save-as-edit/reports-dialog-save-as-edit.component';
import { gridItem } from 'src/app/models';
import { report, reportCategory, saveReportModel } from 'src/app/dashboards/models';
import { ErrorMessage, InfoMessage } from 'src/app/common/messages';
import { Store } from '@ngrx/store';
import { State } from 'src/app/dashboards/state';
import * as mainActions from 'src/app/state/app.actions';
import * as _ from "lodash";
import { I18NextPipe } from 'angular-i18next';

@Component({
    selector: 'app-reports-save-buttons',
    templateUrl: './reports-save-buttons.component.html',
    styleUrls: ['./reports-save-buttons.component.scss'],
    standalone: false
})

export class ReportSaveButtonsComponent implements OnInit {
  @Input() public report: report;
  @Input() public gridItem: gridItem;

  @Output() public cancelButtonNotifier = new EventEmitter();
  @Output() public reportSavedNotifier = new EventEmitter();
  @Output() public saveAsDilogClosedNotifier = new EventEmitter();

  canEdit: boolean = false;

  constructor(private dashboardsService: DashboardService, protected i18nextPipe: I18NextPipe, public dialog: MatDialog, protected store: Store<State>) { }

  ngOnInit(): void {
    this.dashboardsService.getReportsCanEdit().subscribe(value => this.canEdit = value);
  }

  cancelClicked() {
    this.cancelButtonNotifier.emit();
  }

  //saveAsReport() {
  //  this.saveAsButtonNotifier.emit();
  //}

  //saveReport() {
  //  this.saveButtonNotifier.emit();
  //}

  saveAsReport() {
    let dialogRef = this.dialog.open(ReportsDialogSaveAsEditComponent, {
      data: new DialogSaveAsEditData({ ...this.report }, DialogSaveAsEditTypes.SaveAs, this.gridItem),
      panelClass: 'dialog-standard-pannel',
      backdropClass: "backdrop-invisible",
      width: "440px",
      height: "410px"
    });

    dialogRef.afterClosed().subscribe(result => {
      this.saveAsDilogClosedNotifier.emit(result);
      //if (result) {
      //  this.refreshNotifier.emit(true);
      //  this.setInitialSetup();
      //  this.notifyReportModified();
      //}
    });
  }

  saveReport() {
    this.gridItem.setup.reportType = this.gridItem.type;
    let setup = _.cloneDeep(this.gridItem.setup);
    if (this.gridItem.setup["G"]) {
      setup["G"] = setup["G"].filter(g => g.toString().indexOf("_") < 0).map(g => Number(g));
    }
    const saveReportModel: saveReportModel = {
      setup: setup,
      id: this.report.id,
      shortDescription: this.report.shortDescription,
      subReportId: this.report.subReportId,
      userDescription: this.report.userDescription === undefined ? "" : this.report.userDescription,
      // Because the type of categoryId is nullable number, not a string or undefined
      categoryId: !this.report.categoryId ? null : this.report.categoryId
    };

    this.dashboardsService.SaveReport(saveReportModel).subscribe(
      (d) => {
        if (d == 0) {
          this.store.dispatch(mainActions.addMessage({ message: new InfoMessage(this.i18nextPipe.transform('messages:Report Saved!'), "") }));
          //this.setInitialSetup();
          //this.notifyReportModified();
          this.reportSavedNotifier.emit();
        } else if (d == -2) {
          this.store.dispatch(mainActions.addMessage({
            message: new ErrorMessage(
              this.i18nextPipe.transform("messages:Couldn't save report!"),
              this.i18nextPipe.transform('messages:Name is in use.'))
          }));
        } else {
          this.store.dispatch(mainActions.addMessage({ message: new ErrorMessage(this.i18nextPipe.transform("messages:Couldn't save report!"), "") }));
        }
      },
      (error) => {
        this.store.dispatch(mainActions.addMessage({ message: new ErrorMessage(this.i18nextPipe.transform("messages:Couldn't save report!"), "") }));
      }
    );
  }
}
